// import polyfills first
import './polyfills'

import './main'



// WEBPACK FOOTER //
// ./src/index.tsx